import { Directive, ElementRef, AfterViewInit, inject } from '@angular/core';

@Directive({ selector: '[appAutoFocus]' })
export class AutoFocusDirective implements AfterViewInit {
  private element = inject(ElementRef);


  ngAfterViewInit() {
    this.element.nativeElement.focus();
  }
}
